import { Component, OnInit } from '@angular/core';
import { ConfigInfo } from 'src/lib/entity/remote-config';
import { AngularFirestore } from '@angular/fire/firestore';
import { CommonService } from 'src/lib/services/common-service'

@Component({
  selector: 'config-show',
  templateUrl: './config-show.component.html',
  styleUrls: ['./config-show.component.scss', '../../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss']
})
export class ConfigShowComponent implements OnInit {

  // 参照データ
  configInfo: ConfigInfo;

  constructor(
    private afs: AngularFirestore,
    private commonService: CommonService,
  ) { }

  ngOnInit(): void {
    this.reloadConfigInfo();
  }

  private reloadConfigInfo() {
    this.afs.collection<ConfigInfo>("config")
    .valueChanges()
    .subscribe((value: any) => {
      const configDetail = value[0];

      this.configInfo = {
        configInfo1: configDetail.minimumSupportedIosVersion,
        configInfo2: configDetail.minimumSupportedAndroidVersion,
        configInfo3: configDetail.androidSoftwareDecoderModelList,
        configInfo4: configDetail.changeBroadcastTargetDelayTimeSec,
        configInfo5: configDetail.isAwsMode
      };
      this.commonService.setConfigData(this.configInfo)
    });
  }
}
